import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpfPipe } from './pipes/cpf.pipe';
import { PaymentTypePipe } from './pipes/payment-type.pipe';
import { AssistedModeDialogComponent } from './modals/assisted-mode-dialog/assisted-mode-dialog.component';

@NgModule({
  declarations: [CpfPipe, PaymentTypePipe, AssistedModeDialogComponent],
  imports: [CommonModule],
  exports: [CpfPipe, PaymentTypePipe],
})
export class SharedModule {}
